import { Labels } from '../../shared-components/global/labels';

Labels.set('ui-wizard', 'completedStep', 'Užbaigtas žingsnis');
Labels.set('ui-wizard', 'next', 'Kitas');
Labels.set('ui-wizard', 'back', 'Atgal');
Labels.set('ui-wizard', 'cancel', 'Atšaukti');
